/**
 * M7 S32: the Case line (spec §2.5): a word, never a number (Rumour, Circumstantial, Documented, Damning).
 */
import type { ReactNode } from 'react'
import type { LogsConfig } from './models/config'
import type { CaseLineView } from './models/logs'

export function CaseLine(p: { view: CaseLineView; config: LogsConfig }): ReactNode {
  return (
    <div className="lg-case" data-testid="logs-case-line" data-line={p.view.line}>
      <span className="lg-case__label">{p.config.caseLine.label}</span>
      <span className="lg-case__word">{p.view.word}</span>
      <span className="lg-case__hint">{p.view.hint}</span>
    </div>
  )
}
